import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
interface MobileSortModalProps {
  isOpen: boolean;
  onClose: () => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
}
const sortOptions = [{
  label: 'Best Match',
  value: 'best-match'
}, {
  label: 'Top Rated',
  value: 'top-rated'
}, {
  label: 'Price: Low to High',
  value: 'price-low-high'
}, {
  label: 'Price: High to Low',
  value: 'price-high-low'
}];
export function MobileSortModal({
  isOpen,
  onClose,
  sortBy,
  onSortChange
}: MobileSortModalProps) {
  const reduceMotion = useReducedMotion();
  const handleSortChange = (value: string) => {
    onSortChange(value);
    onClose();
  };
  return <AnimatePresence data-id="element-1481" data-mp="104uivzzer9zr">
    {isOpen && <div className="fixed inset-0 z-[200] flex items-end" role="dialog" aria-modal="true" aria-labelledby="sort-sheet-title" data-id="element-1482" data-mp="105njskbor59z">
      <motion.button type="button" aria-label="Close sort options" onClick={onClose} className="absolute inset-0 bg-black/45" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: reduceMotion ? 0 : 0.16
      }} data-id="element-1483" data-mp="2uhttfeoxle06" />
      <motion.section className="relative w-full max-h-[80vh] overflow-y-auto rounded-t-2xl bg-white shadow-2xl" initial={reduceMotion ? false : {
        y: '100%'
      }} animate={{
        y: 0
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        y: '100%'
      }} transition={{
        duration: reduceMotion ? 0.1 : 0.24,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-1484" data-mp="25b6lhb0orhrc">
        <div className="sticky top-0 z-10 rounded-t-2xl border-b border-gray-100 bg-white px-4 pb-3 pt-2" data-id="element-1485" data-mp="2j1s551xyrvqa">
          <div className="mx-auto h-1 w-10 rounded-full bg-gray-300" data-id="element-1486" data-mp="2o269a8wg2lj1" />
          <div className="mt-3 flex items-center justify-between" data-id="element-1487" data-mp="29anu2dbesv0q"><h2 id="sort-sheet-title" className="text-lg font-bold text-gray-900" data-id="element-1488" data-mp="2ea0giwydc02s">Sort by</h2><button type="button" onClick={onClose} className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition-colors duration-150 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Close" data-id="element-1489" data-mp="2e7xipqqz52ni"><XIcon className="h-5 w-5" data-id="element-1490" data-mp="3gl9wqwpnd3pf" /></button></div>
        </div>
        <div className="p-4 pb-[calc(env(safe-area-inset-bottom)+20px)]" data-id="element-1491" data-mp="3bmysd1i4flel"><div className="space-y-1" data-id="element-1492" data-mp="3blnn0x9125ld">{sortOptions.map(option => <button key={option.value} type="button" onClick={() => handleSortChange(option.value)} className={`flex w-full items-center justify-between rounded-xl px-4 py-3.5 text-left transition-[background-color,color] duration-150 ${sortBy === option.value ? 'bg-brand-soft text-brand' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1493" data-mp="37ktv7ssgs6n7"><span className="text-sm font-semibold" data-id="element-1494" data-mp="2svfpcuo3k7ck">{option.label}</span>{sortBy === option.value && <CheckIcon className="h-5 w-5" data-id="element-1495" data-mp="2nyp8i54gx7q3" />}</button>)}</div></div>
      </motion.section>
    </div>}
  </AnimatePresence>;
}